import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IPathService = ( createDecorator('pathService'));
export { IPathService };
